import {Component, OnInit, OnDestroy} from "@angular/core";
import * as Communication from "../communication/index";
import {ActivatedRoute} from "@angular/router";
import {Config} from "../../environments/environment";
import { Subscription } from 'rxjs';
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {NotificationService} from "../shared/common/NotificationService";
import {ToolbarEventPageEnum, ToolbarEvent} from "../shared/common/ToolbarEvent";
import {TranslateService} from '@ngx-translate/core';

declare var $:any;

/**
 * This class represents the lazy loaded AccountComponent.
 */
@Component({
    selector: 'sd-docRequest',
    templateUrl: 'docRequest.component.html',
    styleUrls: ['docRequest.component.css'],
    providers: [Communication.PublicLinkService],
    standalone: false
})
export class DocRequestComponent implements OnInit, OnDestroy {

  publicLinkCode:string="";
  publicLink:Communication.PublicLink;
  params:any={};
  infoTranslation:string;
  subscriptions:Subscription[] = [];

  constructor(
              private publiclinkApi:Communication.PublicLinkService,
              private activatedRoute:ActivatedRoute,
              private toolbarService: ToolbarService,
              private notificationService: NotificationService,
              private translate: TranslateService
  )
  {

  }

  ngOnInit() {

    this.subscriptions.push(this.activatedRoute.params.subscribe(
      (param) => {
        //convert string to number with +
        this.publicLinkCode = param['code'];
        console.warn("public link code:", this.publicLinkCode);


        if(this.publicLinkCode === null || this.publicLinkCode === undefined){
          this.notificationService.showAccessDenied();
          return;
        } else {
          this.getPublicLink();
        }

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }))

    this.infoTranslation = this.translate.instant("Bilgileri");
    this.toolbarService.action(new ToolbarEvent(ToolbarEventPageEnum.DOC_REQUEST, "", null, "", "", "", "", "", ""));
  }

  getPublicLink(){
    this.subscriptions.push(this.publiclinkApi.publicLinkCodeGet(this.publicLinkCode).subscribe(
      (response:Communication.PublicLink) => {
        console.log("publicLink ",response)
        this.publicLink = response;
      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }))
  }


  sendDocumentForSing(form:any){

    this.subscriptions.push(this.publiclinkApi.jobsPublicLinkCodePost(
      this.publicLinkCode,
      form.recipient1Name, form.recipient1Email, form.recipient1CitizenId,
      form.recipient2Name, form.recipient2Email, form.recipient2CitizenId,
      form.recipient3Name, form.recipient3Email, form.recipient3CitizenId,
      form.recipient4Name, form.recipient4Email, form.recipient4CitizenId
    ).subscribe(
     (response) => {

       //this.notificationService.documentSingingRequestSent();

       let returnUrl = this.publicLink.returnUrl;
       this.notificationService.showDocumentSigningRequestSentToRecipient(function (isConfirmed:boolean) {
         if(isConfirmed){
           if(returnUrl) {
             window.location.href = returnUrl;
           } else {
             let win:any = window.open("about:blank", "_self");
             win.close();
           }
         }
       });

       console.log("Document signing request was sent",response)

    }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }))

  }

  ngOnDestroy() {
    this.subscriptions.forEach(
      (s:Subscription) => s.unsubscribe()
    );
  }
}
